import { useRecoilState } from 'recoil';
import React, { useState } from 'react';
import { mainBlueColor, btnColor } from '../../../GlobalState';
import {
  TableRow,
  makeStyles,
  createStyles,
  Theme,
  withStyles,
  TableCell,
  TableHead
} from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';
import { Checkbox } from '@material-ui/core';
import { CustomTooltip } from '../../tooltip/CustomTooltip';
import { tooltipContents } from '../../tooltip/Const';
type Tprops = {
  layer: number;
  isChecked?: boolean;
  onSelectAll?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const LayerModeTableHead: React.FC<Tprops> = (props: Tprops) => {
  const { layer, isChecked, onSelectAll } = props;

  const [mainColor] = useRecoilState(mainBlueColor);

  const StyledTableCell = withStyles(theme => ({
    head: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
      borderRight: '1px #CCCCCC solid'
    },
    body: {
      fontSize: 14,
      padding: 0,
      height: 60,
      borderRight: '1px #CCCCCC solid'
    }
  }))(TableCell);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      table: {
        padding: 8,
        backgroundColor: `${mainColor} !important`,
        color: '#FFFFFF',
        fontWeight: 'bold'
      },
      multiLinesTable: {
        padding: 0,
        backgroundColor: `${mainColor} !important`,
        color: '#FFFFFF',
        fontWeight: 'bold'
      },
      subLayerCell: {
        padding: 8,
        borderBottom: `1px ${mainColor} solid`
      }
    })
  );

  const classes = useStyles();

  const [buttonColor] = useRecoilState(btnColor);

  return (
    <>
      <TableHead>
        <TableRow>
          <StyledTableCell
            style={{ width: 60 }}
            className={classes.table}
            align='center'
          >
            {onSelectAll && (
              <CustomTooltip title={tooltipContents.selectAll} placement='top'>
                <Checkbox
                  checked={isChecked}
                  onChange={event => {
                    onSelectAll && onSelectAll(event);
                  }}
                  style={{ color: isChecked ? buttonColor : '#FFFFFF' }}
                />
              </CustomTooltip>
            )}
          </StyledTableCell>
          <StyledTableCell
            style={{ minWidth: 40 }}
            className={classes.table}
            align='center'
          >
            {layer !== 5 && '明細'}
          </StyledTableCell>
          <StyledTableCell
            style={{ minWidth: 40 }}
            className={classes.table}
            align='center'
          ></StyledTableCell>
          <StyledTableCell
            style={{ minWidth: 40 }}
            className={classes.table}
            align='center'
          >
            {layer === 1 ? '大項目' : '小項目'}
          </StyledTableCell>
          <StyledTableCell
            style={{ minWidth: 40 }}
            className={classes.table}
            align='center'
          >
            仕様
          </StyledTableCell>
          <StyledTableCell
            style={{ minWidth: 40 }}
            className={classes.multiLinesTable}
            align='center'
          >
            <div className={classes.subLayerCell}>数量</div>
            <div className={classes.subLayerCell}>（原価数量）</div>
          </StyledTableCell>
          <StyledTableCell
            style={{ minWidth: 40 }}
            className={classes.multiLinesTable}
            align='center'
          >
            <div className='help-position'>
              <div className={classes.subLayerCell}>単位</div>
              <CustomTooltip title={tooltipContents.itemUnit} placement='right'>
                <HelpIcon style={{ marginLeft: 8 }} />
              </CustomTooltip>
            </div>
            <div className={classes.subLayerCell}>（原価単位）</div>
          </StyledTableCell>
          <StyledTableCell
            style={{ minWidth: 40 }}
            className={classes.multiLinesTable}
            align='center'
          >
            <div className={classes.subLayerCell}>単価</div>
            <div className={classes.subLayerCell}>（原価単価）</div>
          </StyledTableCell>
          <StyledTableCell
            style={{ minWidth: 40 }}
            className={classes.multiLinesTable}
            align='center'
          >
            <div className={classes.subLayerCell}>見積金額</div>
            <div className={classes.subLayerCell}>（原価金額）</div>
          </StyledTableCell>
          <StyledTableCell
            style={{ minWidth: 40 }}
            className={classes.table}
            align='center'
          >
            粗利
          </StyledTableCell>
          <StyledTableCell
            style={{ minWidth: 40 }}
            className={classes.table}
            align='center'
          >
            粗利率
          </StyledTableCell>
          <StyledTableCell
            style={{ minWidth: 40 }}
            className={classes.multiLinesTable}
            align='center'
          >
            <div className="help-position">
            <div className={classes.subLayerCell}>備考</div>
            <CustomTooltip
                title={tooltipContents.author_memo}
                placement="right"
              >
                <HelpIcon
                  style={{ marginLeft:8}}
                />
              </CustomTooltip>
              </div>
            <div className={classes.subLayerCell}>（社内用メモ）</div>
          </StyledTableCell>
          <StyledTableCell
            style={{ minWidth: 40 }}
            className={classes.table}
            align='center'
          >
            削除
          </StyledTableCell>
          <StyledTableCell
            style={{ minWidth: 120 }}
            className={classes.table}
            align='center'
          >
            コピー
          </StyledTableCell>
        </TableRow>
      </TableHead>
    </>
  );
};
